import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background:
    radial-gradient(
      120% 90% at 50% 42%,
      rgba(58, 137, 255, 0.16) 0%,
      rgba(0, 0, 0, 0) 48%
    ),
    rgba(0, 0, 0, 0.76);
  backdrop-filter: blur(8px);
`;

export const Card = styled.div`
  position: relative;
  width: min(294px, calc(100vw - 32px));
  aspect-ratio: 281 / 367;
  overflow: hidden;
  border-radius: 22px;
  background: #071525;
  box-shadow:
    0 28px 70px rgba(0, 0, 0, 0.58),
    0 0 34px rgba(67, 131, 211, 0.24);
  animation: promoPopupIn 220ms ease-out;

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    pointer-events: none;
  }

  &::before {
    top: 0;
    height: 34%;
    background: linear-gradient(
      180deg,
      rgba(2, 8, 15, 0.92) 0%,
      rgba(10, 36, 60, 0.58) 48%,
      rgba(8, 19, 31, 0) 100%
    );
  }

  &::after {
    bottom: 0;
    height: 34%;
    background: linear-gradient(
      180deg,
      rgba(4, 10, 18, 0) 0%,
      rgba(6, 12, 21, 0.62) 52%,
      rgba(3, 7, 13, 0.94) 100%
    );
  }

  @keyframes promoPopupIn {
    from {
      opacity: 0;
      transform: translateY(12px) scale(0.97);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

export const Video = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: 50% 42%;
`;

export const FullCardLink = styled.a`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: block;
  text-decoration: none;
  cursor: pointer;
`;

export const TextLayer = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  padding: 8px 8px 0;
  text-align: center;
  color: #fff;
  pointer-events: none;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 18px;
`;

export const AdLabel = styled.span`
  color: rgba(77, 157, 255, 0.88);
  font-family: Figtree, sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.2px;
`;

export const CloseButton = styled.button`
  position: relative;
  z-index: 4;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  pointer-events: auto;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 11px;
    left: 6px;
    width: 12px;
    height: 1.5px;
    border-radius: 999px;
    background: rgba(77, 157, 255, 0.72);
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }

  &:hover::before,
  &:hover::after,
  &:focus-visible::before,
  &:focus-visible::after {
    background: rgba(151, 197, 255, 0.95);
  }

  &:focus-visible {
    outline: 2px solid rgba(151, 197, 255, 0.65);
    outline-offset: -2px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  color: #fff;
  font-family: Figtree, sans-serif;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.08;
  letter-spacing: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.34);
`;

export const Subtitle = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  color: rgba(220, 235, 255, 0.82);
  font-family: Figtree, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: 0;
`;

export const CtaLink = styled.a`
  position: absolute;
  left: 50%;
  bottom: 16px;
  z-index: 4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 137px;
  height: 40px;
  padding: 0 20px;
  border-radius: 999px;
  border: 1px solid rgba(120, 181, 255, 0.68);
  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.18) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    #3f91ff;
  color: #fff;
  font-family: Figtree, sans-serif;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0;
  text-decoration: none;
  white-space: nowrap;
  transform: translateX(-50%);
  box-shadow:
    0 8px 18px rgba(23, 101, 216, 0.38),
    inset 0 1px 2px rgba(255, 255, 255, 0.22),
    inset 0 -8px 12px -8px rgba(177, 217, 255, 0.34);
  transition:
    transform 0.16s ease,
    filter 0.16s ease;

  &:hover {
    transform: translateX(-50%) translateY(-1px);
    filter: brightness(1.06);
  }

  &:active {
    transform: translateX(-50%) scale(0.98);
    filter: brightness(1.08);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.92);
    outline-offset: 3px;
  }

  @media (max-width: 340px) {
    min-width: 126px;
    height: 37px;
    font-size: 13px;
  }
`;
